// extracted by mini-css-extract-plugin
export default {"scope":"OiRir","scope--is-compact":"_4WO4S","label":"Fn0lk"};